import React, { Component } from 'react'
import PropTypes from 'prop-types'
import axios from 'axios'
import QRCode from 'qrcode'
import { Toast } from 'antd-mobile'
import { CSSTransition } from 'react-transition-group'
import {
    device,
    setLogin,
    shareTypeToCode,
    urlObjectToStrings,
    appShare,
    tools
} from './../../assets/js/utils'
import qrcodeImg from './../../assets/images/qrcode_bg2.png'
import './index.less'
let broswerShare = null

class Share extends Component {
  static propTypes = {
      data: PropTypes.object
  };

  constructor (props) {
      super(props)
      this.state = {
          qrcodeUrl: '', // 二维码url,
          posterUrl: '',
          isShowWxModal: false, // 是否显示微信引导层
          isShowQrcodeModal: false // 是否显示二维码弹窗
      }

      // 分享信息
      this.shareInfo = {
          title: '', // 分享标题
          desc: '', // 分享描述
          link: '', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: '' // 分享图标
      }

      // 用户信息
      this.inviteCode = ''
  }

  componentDidMount () {
      // 获取用户信息
      this.getUserInfo()

      if (this.props.data.sublist && this.props.data.sublist.length > 0) {
          const { title, content, shareIconUrl, url } = this.props.data.sublist[0]
          this.shareInfo = {
              title: title || '',
              desc: content || '',
              link: url || window.location.href.split('?')[0],
              imgUrl: shareIconUrl || ''
          }
      }

      // 阻止分享组件滑动
      this.preventFixedScroll()
  }

  /**
   * 获取用户信息
   */
  async getUserInfo () {
      const res = await axios.get('/gateway/v3/user/info')
      const data = res.data.data
      if (!data) {
          return
      }
      this.inviteCode = data.inviteCode || ''
      this.shareInfo.link = urlObjectToStrings(this.shareInfo.link, {
          gatewayInviteCode: this.inviteCode
      })
      this.initConfig()
  }

  /**
   * 初始化
   */
  initConfig () {
      // 生成 shareLink  url
      this.handleQrcode()

      if (device.isWeixin) {
      // 初始化微信分享
          return import(/* webpackChunkName: "wxShare" */ './wx-share').then(
              module => {
                  const wxShare = module.default
                  wxShare.init(this.shareInfo)
              }
          )
      }

      if (device.qqBrowserVersion || device.ucBrowserVersion) {
      // 初始化浏览器分享
          return import(
              /* webpackChunkName: "broswerShare" */ './broswer-share'
          ).then(module => {
              broswerShare = module.default
              broswerShare.init(this.shareInfo)
          })
      }
  }

  /**
   * 分享
   * @param {Object} item
   */
  handleShare (shareType) {
      // 未登录跳转登录
      const isLogin = this.inviteCode
      if (!isLogin) {
          setLogin()
          return
      }

      // 二维码分享
      if (shareType === 4) {
          this.setState({
              isShowQrcodeModal: true
          })
          return
      }

      // 复制分享
      if (shareType === 5) {
          this.copyText()
      }

      // 不是二维码/复制分享
      if (shareType !== 4 && shareType !== 5) {
          const isApp = sessionStorage.getItem('source') === 'app'
          if (isApp) {
              // APP调起方法
              const { link, title, desc, imgUrl } = this.shareInfo
              appShare({
                  shareType: shareTypeToCode(shareType),
                  shareUrl: link,
                  shareTitle: title,
                  shareUrlContent: desc,
                  shareImageUrl: imgUrl
              })
          } else if (device.isWeixin) {
              // 微信显示弹层
              if (shareType === 6) {
                  const { link, title, imgUrl } = this.shareInfo
                  window.location.href = `https://service.weibo.com/share/share.php?url=${encodeURIComponent(link)}&title=${title}&pic=${imgUrl}`
                  console.log()
              } else {
                  this.setState({
                      isShowWxModal: true
                  })
              }
          } else if (device.qqBrowserVersion || device.ucBrowserVersion) {
              // QQ、UC调起浏览器分享api
              console.log(broswerShare, '浏览器分享方法')
              broswerShare.share(shareTypeToCode(shareType))
          } else {
              // 普通浏览器
              if (shareType === 6) {
                  const { link, title, imgUrl } = this.shareInfo
                  window.location.href = `https://service.weibo.com/share/share.php?url=${encodeURIComponent(link)}&title=${title}&pic=${imgUrl}`
              } else {
                  Toast.info('您的浏览器暂不支持此方式, 请使用二维码或复制链接分享', 2)
              }
          }
      }
  }

  /**
   * 生成分享链接图片 url
   */
  handleQrcode () {
      QRCode.toDataURL(this.shareInfo.link, {
          margin: 0
      })
          .then(qrcodeUrl => {
              this.setState(
                  {
                      qrcodeUrl
                  },
                  () => {
                      this.drawPoster()
                  }
              )
          })
          .catch(err => {
              console.error(err)
          })
  }

  /**
   * 生成分享海报图片 url
   */
  drawPoster () {
      const canvas = document.getElementById('canvas')

      const dpr = window.devicePixelRatio
      const canvasW = canvas.clientWidth * dpr
      const canvasH = canvas.clientHeight * dpr
      canvas.width = canvasW
      canvas.height = canvasH

      const ctx = canvas.getContext('2d')

      const posterBg = new Image()
      posterBg.src = qrcodeImg
      posterBg.onload = () => {
          ctx.drawImage(posterBg, 0, 0, canvasW, canvasH)

          const qrcodeImg = new Image()
          qrcodeImg.src = this.state.qrcodeUrl
          qrcodeImg.onload = () => {
              ctx.drawImage(
                  qrcodeImg,
                  (162 / 650) * canvasW,
                  (325 / 880) * canvasH,
                  (325 / 880) * canvasH,
                  (325 / 880) * canvasH
              )
              const posterUrl = canvas.toDataURL()
              this.setState({
                  posterUrl: posterUrl
              })
          }
      }
  }

  /**
   * 关闭二维码弹层
   */
  closeQrcodeModal = () => {
      this.setState({
          isShowQrcodeModal: false
      })
  };

  /**
   * 关闭微信弹层
   */
  closeWxModal = () => {
      this.setState({
          isShowWxModal: false
      })
  };

  /**
   * 复制事件
   */
  copyText () {
      const copyDOM = document.querySelector('#copyText')
      const range = document.createRange()
      // 选中需要复制的节点
      range.selectNode(copyDOM)
      // 执行选中元素
      window.getSelection().addRange(range)
      // 执行 copy 操作
      const successful = document.execCommand('copy')
      console.log(successful)
      try {
          if (successful || successful === undefined) {
              Toast.success('复制成功', 1.5)
          } else {
              Toast.fail('复制失败，请使用其他分享方式', 1.5)
          }
      } catch (err) {
          Toast.fail('复制失败，请使用其他分享方式', 1.5)
      }
      // 移除选中的元素
      window.getSelection().removeAllRanges()
  }

  // 修复QQ浏览器分享组件不吸底
  preventFixedScroll () {
      const el = document.querySelector('.share-group')
      el.addEventListener('touchmove', (e) => {
          e.preventDefault()
      })
  }

  render () {
      const { buriedPointEvent, data: { position, trackId, style = {}, sublist } } = this.props
      const { isShowWxModal, isShowQrcodeModal, posterUrl } = this.state
      const { backgroundPicUrl = '', backgroundColor = '', textColor = '' } = style

      return (
          <div className="share">
              <div
                  className="share-group"
                  style={{
                      backgroundColor: backgroundColor,
                      backgroundImage: `url(${backgroundPicUrl || ''})`
                  }}
              >
                  {sublist.map(
                      ({ id, shareType, shareTypeName, isShowShareTypeName, iconUrl, title }, index) => {
                          return (
                              <div
                                  key={id}
                                  className={'item statistics-dom'}
                                  id={shareType === 5 ? 'copyBtn' : ''}
                                  onClick={() => {
                                      buriedPointEvent({
                                          button_name: `${trackId}-${shareTypeName}`,
                                          button_id: `${id}`,
                                          button_order: `${index + 1}`,
                                          area_order: position,
                                          button_area: `${position}-${trackId}`
                                      })
                                      this.handleShare(shareType)
                                  }}
                              >
                                  <img src={iconUrl} alt="" />
                                  {isShowShareTypeName === 1 && (
                                      <p style={{ color: `${textColor}` }}>{shareTypeName}</p>
                                  )}
                              </div>
                          )
                      }
                  )}
              </div>
              <CSSTransition
                  in={isShowWxModal}
                  timeout={500}
                  classNames="fades"
                  unmountOnExit
              >
                  <div className="wx-modal" onClick={this.closeWxModal} />
              </CSSTransition>

              <CSSTransition
                  in={isShowQrcodeModal}
                  timeout={500}
                  classNames="fades"
                  unmountOnExit
              >
                  <div className="qrcode-modal">
                      <div className="modal-content">
                          <img src={posterUrl} alt="" />

                          <div className="btn-close" onClick={this.closeQrcodeModal} />
                      </div>
                  </div>
              </CSSTransition>

              <span id="copyText">{this.shareInfo.link}</span>

              <canvas id="canvas" className="my-canvas" />
          </div>
      )
  }
}

export default Share
